export default "__VITE_ASSET__919ce56d__"